import api from "./api";

export const FetchChatResponse = async (message: string, switchStatus: string, azuresearchId: string) => {
    const response = await api.get(process.env.REACT_APP_IDMAPP + encodeURIComponent(message) + '&azuresearchId=' + encodeURIComponent(azuresearchId) + '&switchStatus=' + encodeURIComponent(switchStatus))
    return response.data.response;
}

export const fetchBenchmarkingChatResponse = async (message: string, history: any) => {
    const response = await fetch(process.env.REACT_APP_BENCHMARKING + encodeURIComponent(message), {
        method: 'POST',
        body: JSON.stringify({ 'history': history }),
    }).then((response) => {
        if (response.status === 401 || response.status === 403) {
            window.location.href = '/.auth/login/aad?post_login_redirect_uri=/';
        }
        return response.json()
    }).catch((err) => {
        return { response: 'An error occured. Please try again.' }

    })
    if (response.status === 401 || response.status === 403) {
        window.location.href = '/.auth/login/aad?post_login_redirect_uri=/';
    }
    return response.response;
}
